/* import __COLOCATED_TEMPLATE__ from './identity-verification-phone.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();